import React from "react";
import {Box} from "@mui/system";
import {processSpacing, parseEscapedText, replaceHttp, parseMarkdown} from "_helpers";
import linkifyHtml from "linkify-html";
import dompurify from "dompurify";
import fustatSemiBoldUrl from "../../../../fonts/Fustat/Fustat-SemiBold.ttf";

function ProactiveMetricsMessageIframe({
  text,
  index,
  messageSource,
}) {
  const offset = 20;

    let formattedText = text;
    // Formatting for Mobius messages
    if (messageSource && messageSource.toLowerCase() === 'mobius') {
        // Decode entities
        formattedText = parseEscapedText(formattedText);
        formattedText = parseMarkdown(formattedText, true);
        formattedText = replaceHttp(formattedText);
        formattedText = dompurify.sanitize(formattedText);
        formattedText = linkifyHtml(formattedText, {
          target: "_blank",
          rel: "noopener noreferrer",
        });
        formattedText = processSpacing(formattedText);
    }

    formattedText = `<base target="_blank">` + formattedText;
    const fontStyle = `
    <style>
      @font-face {
        font-family: FustatSemiBold;
        src: url("${fustatSemiBoldUrl}") format("truetype");
        font-weight: 600;
        font-style: normal;
        font-display: swap;
      }
      .fustat-semi-bold, body { font-family: FustatSemiBold; font-size: 14px; }
    </style>
  `;
    const iframeHtml =
        fontStyle + `<div class="fustat-semi-bold">${formattedText}</div>`;

  const onLoad = () => {
    return setTimeout(() => {
      const obj = document.getElementById(`${index}-pmc-messageFrame`);
      if (obj) {
        obj.style.height =
          obj.contentWindow.document.body.scrollHeight + offset + "px";
      }
    }, 50);
  };

    return(
        <Box component={'iframe'}
             id={`${index}-pmc-messageFrame`}
             scrolling={'no'}
             sx={styles.iframe}
             srcDoc={iframeHtml}
             onLoad={onLoad}
        />
    )
}

export default React.memo(ProactiveMetricsMessageIframe)

const styles = {
    iframe: {
        width: '100%',
        border: 0,
    },
}